var _defs, _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuthCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-5 -5 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.151,
    y1: 0.816,
    x2: 0.846,
    y2: 0.187,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#61adfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffadfa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffadfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61adfa"
  })))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "myClip",
    clipPathUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "50%",
    cy: "50%",
    r: "50%"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143",
    transform: "translate(-490.874 -377.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M627.876,397.528a85.752,85.752,0,1,0,42.876,74.263A85.752,85.752,0,0,0,627.876,397.528Zm4.02-6.962a93.792,93.792,0,1,0,46.9,81.225A93.789,93.789,0,0,0,631.9,390.566Z",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.67,
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M551.351,478.338l10.719-13.4,16.078,13.4,24.118-37.516,13.4,10.719-34.837,48.235Z",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.765,
    fill: "url(#linear-gradient-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthCheck);
export default __webpack_public_path__ + "static/media/auth_check.7d418be106c2c5d58d3c0b8e10a1fa44.svg";
export { ForwardRef as ReactComponent };